<!-- Etapa: Dados do Investidor (PF) -->
<ng-container *ngIf="etapa === 'dados' && typeForm === 'PF'">
  <div class="row col-12">
    <form class="box-form col-12 p-5" [formGroup]="formInvestidorPF">
      <fieldset>
        <legend class="form-title">1 - Dados do Investidor</legend>
        <hr class="mt-2">
        <div class="form-row p-4 custom-box">
            <b class="text-info">
              Importante: O cadastro de Pessoa Física para garantia Ordinária deve ser realizado através do APP FGC <br>
              Este canal é exclusio para Pessoa Jurídica ou Pessoa Física - Garantia Especial (DPGE)
            </b>
        </div>
          <div class="form-row mt-4">
            <div class="form-group col-sm-12 col-md-6">
              <label class="form-label">CPF Investidor <b class="text-danger">*</b></label>
              <input data-testid="cpf-pf" mask="000.000.000-00" formControlName="documentoIdentificador" autocomplete="off" placeholder="Ex: 000.000.000-00" name="documentoIdentificador" type="text" class="form-control">
              <span class="error-form ml-2" *ngIf="documentoIdentificadorPF.invalid && (documentoIdentificadorPF.dirty || documentoIdentificadorPF.touched)">Campo obrigatório.</span>
            </div>
            <div class="form-group col-sm-12 col-md-6">
              <label class="form-label">Nome Investidor <b class="text-danger">*</b></label>
              <input data-testid="nome-pf" maxlength="150" placeholder="Digite seu nome" formControlName="nome" autocomplete="off" name="nomeCompleto" type="text" class="form-control">
            <span class="error-form ml-2" *ngIf="nomePF.invalid && (nomePF.dirty || nomePF.touched)">Campo obrigatório.</span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-sm-12 col-md-6">
              <label class="form-label">Email <b class="text-danger">*</b></label>
              <input data-testid="email-pf" formControlName="email" autocomplete="off" placeholder="example@example.com" name="email" type="email" class="form-control">
              <span class="error-form ml-2" *ngIf="emailPF.invalid && (emailPF.dirty || emailPF.touched)">Campo obrigatório.</span>
            </div>
            <div class="form-group col-sm-12 col-md-6">
              <label class="form-label">Confirme o Email <b class="text-danger">*</b></label>
              <input data-testid="confirma-email-pf" formControlName="confirmaEmail" autocomplete="off" placeholder="example@example" name="emailConfirmar" type="email" class="form-control">
            <span class="error-form ml-2" *ngIf="confirmaEmailPF.invalid && (confirmaEmailPF.dirty || confirmaEmailPF.touched)">Campo obrigatório.</span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-sm-12 col-md-4">
              <label  class="label form">DDI <b class="text-danger">*</b></label>
              <select data-testid="ddi-pf" formControlName="codigoDdi" autocomplete="off" name="ddi" type="text" class="form-control">
                <option selected value="">Selecione uma das opções</option>
                <option value="+55">Brasil</option>
                <option *ngFor="let opt of tableDdi" value="{{opt.code}}">{{opt.name}}</option>
              </select>
            <span class="error-form ml-2" *ngIf="ddiPF.invalid && (ddiPF.dirty || ddiPF.touched)">Campo obrigatório.</span>
            </div>
            <div class="form-group col-sm-12 col-md-4">
              <label class="label form">Telefone </label><i mdbTooltip='Este campo só é obrigatório caso o campo "Celular" não seja preenchido.'  cement="top" class="ml-3 fas fa-question-circle"></i>
              <input data-testid="telefone-pf" formControlName="telefone" autocomplete="off" [mask]="maskTelefone(1)" name="telefone" type="text" class="form-control">
              <span class="error-form ml-2" *ngIf="telefonePF.errors?.minlength">Telefone deve ter 10 dígitos.</span>
              <span class="error-form ml-2" *ngIf="telefonePF.invalid && (telefonePF.dirty || telefonePF.touched)">Campo obrigatório.</span>
            </div>
            <div class="form-group col-sm-12 col-md-4">
              <label  class="label form">Celular</label><i mdbTooltip='Este campo só é obrigatório caso o campo "Telefone" não seja preenchido.'  cement="top" class="ml-3 fas fa-question-circle"></i>
              <input data-testid="celular-pf" formControlName="celular" autocomplete="off" [mask]="maskTelefone(2)" name="celular" type="text" class="form-control">
              <span class="error-form ml-2" *ngIf="celularPF.errors?.minlength">Celular deve ter 11 dígitos.</span>
              <span class="error-form ml-2" *ngIf="celularPF.invalid && (celularPF.dirty || celularPF.touched)">Campo obrigatório.</span>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-sm-12 col-md-4">
              <label class="form-label">Data de Nascimento <b class="text-danger">*</b></label>
              <input data-testid="data-nascimento-pf" type="date" class="form-control" formControlName="dataNascimento" autocomplete="off" max="9999-12-31" appLimitarAno>
            </div>
            <div class="form-group mb-0 col-sm-12 col-md-8 d-flex align-items-center justify-content-center">
              <label class="form-label mb-0">
                <mdb-checkbox data-testid="checkbox-incapaz" name="checked" formControlName="incapaz" class="form-label">Incapaz ? (Necessita de assistência/auxilio)</mdb-checkbox>
              </label>
            </div>
          </div>

          <div *ngIf="!maiorDeIdade || incapazPF.value" class="form-row">
            <div class="form-group col-sm-12 col-md-6">
              <label  class="form-label">Documento Identificador Responsável <b class="text-danger">*</b></label>
              <input data-testid="documento-responsavel" formControlName="documentoResponsavel" autocomplete="off" mask="000.000.000-00" name="Documento Responsavel" type="text" class="form-control">
            </div>
            <div class="form-group col-sm-12 col-md-6">
              <label  class="form-label">Nome Responsável <b class="text-danger">*</b></label>
              <input data-testid="nome-responsavel" formControlName="nomeResponsavel" autocomplete="off" name="Nome Responsavel" type="text" class="form-control">
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-6">
              <div class="form-outline">
                <label class="form-label">Senha <b class="text-danger">*</b></label> <i mdbTooltip="Sua senha precisa ter no mínimo 8 caracteres, 1 letra maiúscula e minúsculas e um caracterer especial" placement="top" class="ml-3 fas fa-question-circle"></i>
                <div class="input-group">
                    <input data-testid="senha-pf" [type]="showPassword? 'text' : 'password'" formControlName="senha" autocomplete="off" placeholder="Ex: ************" class="form-control" />
                </div>
                <span class="error-form ml-2" *ngIf="senhaPF.invalid && senhaPF.errors?.required && senhaPF.touched">Campo obrigatório.</span>
                <span class="error-form ml-2" *ngIf="senhaPF.errors?.minlength">A senha deve ter mais que 8 caracteres.</span>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-outline">
                <label class="form-label">Confirme sua senha <b class="text-danger">*</b></label>
                <div class="input-group">
                  <input data-testid="confirma-senha-pf" [type]="showPassword? 'text' : 'password'" formControlName="confirmaSenha" autocomplete="off" class="form-control" placeholder="Ex: ************" />
                  <div class="input-group-text ml-1" style="cursor: pointer">
                    <i [ngClass]="showPassword? 'far fa-eye-slash' : 'fas far fa-eye'" (click)="togglePassword()"></i>
                  </div>
                </div>
                <span class="error-form ml-2" *ngIf="confirmarSenhaPF.invalid && confirmarSenhaPF.errors?.required && confirmarSenhaPF.touched">Campo obrigatório.</span>
                <span class="error-form ml-2" *ngIf="confirmarSenhaPF.errors?.minlength">A senha deve ter mais que 8 caracteres.</span>
              </div>
            </div>
          </div>

          <div class="form-row mt-5">
            <mdb-checkbox data-testid="checkbox-politica-privacidade" name="checked" formControlName="termoAceite" class="form-label">Li e estou de acordo com a <u (click)="termoPoliticaPrivacidade()">Política de privacidade</u>.</mdb-checkbox>
            <span class="error-form ml-2" *ngIf="termPF.invalid && (termPF.dirty || termPF.touched)">Concorde com o termo de aceite.</span>*
          </div>
      </fieldset>
      <div class="form-row mt-5 d-flex justify-content-center">
        <button data-testid="botao-proximo" (click)="proximo.emit()" class="btn" [disabled]="nextDisabled">Próximo</button>
      </div>
    </form>
  </div>
</ng-container>

<!-- Etapa: Dados do Solicitante (PJ / Fundo de Investimento) -->
<ng-container *ngIf="etapa === 'dados' && (typeForm === 'PJ' || typeForm === 'FUNDO_INVESTIMENTO')">
  <div class="row col-12">
    <form class="box-form col-12 p-5" [formGroup]="formInvestidorPJ" autocomplete="off">
      <h3 class="form-title  text-center">1 - Dados do Solicitante</h3>
      <hr mt-2>
      <div class="form-row mt-3">
        <div class="form-group col-sm-12 col-md-6">
          <label class="form-label">Nome <b class="text-danger">*</b></label>
          <input data-testid="nome-pj" autocomplete="off" formControlName="nome" name='nome' type="text" class="form-control">
          <span class="error-form ml-2" *ngIf="nomePJ.invalid && (nomePJ.dirty || nomePJ.touched)">Campo obrigatório.</span>
        </div>
        <div class="form-group col-sm-12 col-md-3">
          <label class="form-label">CPF <b class="text-danger">*</b></label>
          <input data-testid="cpf-pj" autocomplete="off" formControlName="documentoIdentificador" name='documentoIdentificador' mask="000.000.000-00" type="text" class="form-control">
          <span class="error-form ml-2" *ngIf="documentoIdentificadorPJ.invalid && (documentoIdentificadorPJ.dirty || documentoIdentificadorPJ.touched)">Campo obrigatório.</span>
        </div>
        <div class="form-group col-sm-12 col-md-3">
          <label class="form-label">Data de Nascimento <b class="text-danger">*</b></label>
          <input data-testid="data-nascimento-pj" type="date" class="form-control" formControlName="dataNascimento" autocomplete="off" max="9999-12-31" appLimitarAno>
        </div>
      </div>
      <div class="form-row mt-3">
        <div class="col-6">
          <div class="form-outline">
            <label class="form-label" for="form1">Email <b class="text-danger">*</b></label>
            <input data-testid="email-pj" autocomplete="new-username" type="email" formControlName="email" placeholder="example@example.com" class="form-control form-icon-trailing" />
            <span class="error-form ml-2" *ngIf="emailPJ.invalid && (emailPJ.dirty || emailPJ.touched)">Digite um email válido.</span>
          </div>
        </div>
        <div class="col-6">
          <div class="form-outline">
            <label class="form-label" for="form1">Confirme seu email <b class="text-danger">*</b></label>
            <input data-testid="confirma-email-pj" autocomplete="new-username" type="email" formControlName="confirmaEmail" placeholder="example@example.com" class="form-control form-icon-trailing" />
            <div *ngIf="confirmaEmailPJ.touched && confirmaEmailPJ.invalid" class="alert alert-danger">
              <span class="error-form ml-2" *ngIf="confirmaEmailPJ.invalid && (confirmaEmailPJ.dirty || confirmaEmailPJ.touched)">Campo obrigatório.</span>
              <div *ngIf="confirmaEmailPJ.errors.email">O email informado não é válido.</div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row mt-3">
        <div class="col-md-6">
          <div class="form-outline">
            <label class="form-label">Senha <b class="text-danger">*</b></label> <i mdbTooltip='Sua senha precisa ter no mínimo 8 caracteres, 1 letra maiúscula e minúsculas e um caracterer especial: !@#$%^&*(),.?":{}|<>' placement="top" class="ml-3 fas fa-question-circle"></i>
            <div class="input-group">
                <input data-testid="senha-pj" autocomplete="new-password" [type]="showPassword? 'text' : 'password'" formControlName="senha" placeholder="Ex: ************" class="form-control" />
            </div>
            <span class="error-form ml-2" *ngIf="senhaPJ.invalid && senhaPJ.errors?.required && senhaPJ.touched">Campo obrigatório.</span>
            <span class="error-form ml-2" *ngIf="senhaPJ.errors?.minlength">A senha deve ter mais que 8 caracteres.</span>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-outline">
            <label class="form-label">Confirme sua senha <b class="text-danger">*</b></label>
            <div class="input-group">
              <input data-testid="confirma-senha-pj" autocomplete="new-password" [type]="showPassword? 'text' : 'password'" formControlName="confirmaSenha" class="form-control" placeholder="Ex: ************" />
              <div class="input-group-text ml-1" style="cursor: pointer">
                <i [ngClass]="showPassword? 'far fa-eye-slash' : 'fas far fa-eye'" (click)="togglePassword()"></i>
              </div>
            </div>
            <span class="error-form ml-2" *ngIf="confirmarSenhaPJ.invalid && confirmarSenhaPJ.errors?.required && confirmarSenhaPJ.touched">Campo obrigatório.</span>
            <span class="error-form ml-2" *ngIf="confirmarSenhaPJ.errors?.minlength">A senha deve ter mais que 8 caracteres.</span>
          </div>
        </div>
      </div>
      <div class="form-row mt-5">
        <div class="col-md">
          <mdb-checkbox data-testid="checkbox-politica-privacidade" name="checked" formControlName="termoAceite" class="form-label">Li e estou de acordo com a <u (click)="termoPoliticaPrivacidade()">Política de privacidade</u>.<b class="text-danger">*</b></mdb-checkbox>
          <span class="error-form ml-2" *ngIf="termPJ.invalid && termPJ.errors?.required  && senhaPJ.touched">Concorde com o termo de aceite.</span>

        </div>
      </div>
      <div class="form-row mt-5 d-flex justify-content-center">
        <button data-testid="proxima-etapa-email" (click)="proximo.emit()" class="btn" [disabled]="nextDisabled">Próximo</button>
      </div>
    </form>
  </div>
</ng-container>

<!-- Etapa: Dados do Responsável (Entidade) -->
<ng-container *ngIf="etapa === 'dados' && typeForm === 'ENTIDADE'">
  <div class="row col-12">
    <form class="box-form col-12 p-5" [formGroup]="formResponsavelEntidade">
      <fieldset>
        <legend class="form-title">1 - Dados do Responsavel</legend>
        <hr class="mt-2">
          <div class="form-row mt-4">
            <div class="form-group col-sm-12 col-md-6">
              <label class="form-label">Nome <b class="text-danger">*</b></label>
              <input formControlName="nomeContato" autocomplete="off" placeholder="Digite o nome do responsável para contatos" name="nomeContato" type="text" class="form-control">
              <span class="error-form ml-2" *ngIf="nomeContatoResponsavelEntidade.invalid && (nomeContatoResponsavelEntidade.dirty || nomeContatoResponsavelEntidade.touched)">Campo obrigatório.</span>
            </div>
            <div class="form-group col-sm-12 col-md-3">
              <label class="form-label">CPF <b class="text-danger">*</b></label>
              <input mask="000.000.000-00" formControlName="documentoIdentificador" autocomplete="off" placeholder="Ex: 000.000.000-00" name="CPF" type="text" class="form-control">
              <span class="error-form ml-2" *ngIf="documentoIdentificadorResponsavelEntidade.invalid && (documentoIdentificadorResponsavelEntidade.dirty || documentoIdentificadorResponsavelEntidade.touched)">Campo obrigatório.</span>
            </div>
            <div class="form-group col-sm-12 col-md-3">
              <label class="form-label">Data de Nascimento <b class="text-danger">*</b></label>
              <input type="date" class="form-control" formControlName="dataNascimento" autocomplete="off" max="9999-12-31" appLimitarAno>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-sm-12 col-md-6">
              <label class="form-label">Email <b class="text-danger">*</b></label>
              <input formControlName="email" autocomplete="off" placeholder="example@example.com" name="email" type="email" class="form-control">
              <span class="error-form ml-2" *ngIf="emailResponsavelEntidade.invalid && (emailResponsavelEntidade.dirty || emailResponsavelEntidade.touched)">Campo obrigatório.</span>
            </div>
            <div class="form-group col-sm-12 col-md-6">
              <label class="form-label">Confirme o Email <b class="text-danger">*</b></label>
              <input formControlName="confirmaEmail" autocomplete="off" placeholder="example@example.com" name="emailConfirmar" type="email" class="form-control">
            <span class="error-form ml-2" *ngIf="confirmaEmailResponsavelEntidade.invalid && (confirmaEmailResponsavelEntidade.dirty || confirmaEmailResponsavelEntidade.touched)">Campo obrigatório.</span>
            </div>
          </div>

          <div class="form-row">
          <div class="col-md-6">
            <div class="form-outline">
              <label class="form-label">Senha <b class="text-danger">*</b></label> <i mdbTooltip="Sua senha precisa ter no mínimo 8 caracteres, 1 letra maiúscula e minúsculas e um caracterer especial" placement="top" class="ml-3 fas fa-question-circle"></i>
              <div class="input-group">
                  <input [type]="showPassword? 'text' : 'password'" formControlName="senha" autocomplete="off" placeholder="Ex: ************" class="form-control" />
              </div>
              <span class="error-form ml-2" *ngIf="senhaResponsavelEntidade.invalid && senhaResponsavelEntidade.errors?.required && senhaResponsavelEntidade.touched">Campo obrigatório.</span>
              <span class="error-form ml-2" *ngIf="senhaResponsavelEntidade.errors?.minlength">A senha deve ter mais que 8 caracteres.</span>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-outline">
              <label class="form-label">Confirme sua senha <b class="text-danger">*</b></label>
              <div class="input-group">
                <input [type]="showPassword? 'text' : 'password'" formControlName="confirmaSenha" autocomplete="off" class="form-control" placeholder="Ex: ************" />
                <div class="input-group-text ml-1" style="cursor: pointer">
                  <i [ngClass]="showPassword? 'far fa-eye-slash' : 'fas far fa-eye'" (click)="togglePassword()"></i>
                </div>
              </div>
              <span class="error-form ml-2" *ngIf="confirmarSenhaResponsavelEntidade.invalid && confirmarSenhaResponsavelEntidade.errors?.required && confirmarSenhaResponsavelEntidade.touched">Campo obrigatório.</span>
              <span class="error-form ml-2" *ngIf="confirmarSenhaResponsavelEntidade.errors?.minlength">A senha deve ter mais que 8 caracteres.</span>
            </div>
          </div>
        </div>

        <div class="form-row  mt-5">
          <mdb-checkbox name="checked" formControlName="termoAceite" class="form-label">Li e estou de acordo com a <u (click)="termoPoliticaPrivacidade()">Política de privacidade</u>.</mdb-checkbox>
          <span class="error-form ml-2" *ngIf="termResponsavelEntidade.invalid && termResponsavelEntidade.errors?.required  && termResponsavelEntidade.touched">Concorde com o termo de aceite.</span>
        </div>
      </fieldset>
      <div class="form-row mt-5 d-flex justify-content-center">
        <button (click)="proximo.emit()" class="btn" [disabled]="nextDisabled">Próximo</button>
      </div>
    </form>
  </div>
</ng-container>

<!-- Etapa: Validar Email (compartilhada entre PF, PJ/Fundo e Entidade) -->
<ng-container *ngIf="etapa === 'email'">
  <div class="row d-flex justify-content-center">
    <div class="col-12">
      <form class="box-form p-5" [formGroup]="formToken">
        <h3 class="form-title text-center">2 - Validar E-Mail</h3>
        <hr>
        <div class="form-row mt-5 ">
          <h4 class="subtitle-form text-center col-12"> Um código (número de 6 dígitos) foi enviado por E-mail informado anteriormente.</h4>
        </div>
        <div class="form-row mt-4">
          <div class="col-md">
            <h3 class="title-email">
              Digite abaixo o código recebido por E-mail:
            </h3>
         </div>
        </div>

         <div class="form-row mt-5 d-flex justify-content-center">
           <div class="col-md-7">
             <div class="form-outline">
               <input autocomplete="off" data-testid="token-email" type="text" [dropSpecialCharacters]="true"  formControlName="token" placeholder="Digite o código recebido por E-mail" mask=" 0   0   0   0   0   0 " class="form-control text-center">
               <span class="error-form ml-2" *ngIf="token.invalid && (token.dirty || token.touched)">Campo obrigatório.</span>

              </div>
           </div>
        </div>

        <div class="form-row mt-5 d-flex justify-content-center">
          <div class="col-md text-center">
            <span data-testid="reenviar-token" [ngClass]="disableButton" (click)="reenviarToken.emit()">Reenviar código por email</span>
          </div>
        </div>

        <div class="form-row mt-5 d-flex justify-content-center">
          <div class="col-md-4 d-flex justify-content-center">
            <button data-testid="botao-voltar" (click)="voltarToken.emit()" type="button" class="btn">
              Voltar
            </button>
          </div>
          <div class="col-md-4 d-flex justify-content-center">
            <button data-testid="proxima-etapa" (click)="continuarToken.emit()" class="btn">
              Continuar
            </button>
          </div>
        </div>

      </form>
    </div>
  </div>
</ng-container>
